<template>
  <SelectableSearch
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    :allow-custom="props.allowCustom"
    :custom-value="props.customValue"
    :max-length="props.maxLength"
    @update:customValue="emit('update:customValue', $event)"
    :options="props.options"
    idKey="id"
    labelKey="building_nm"
    :formatter="props.formatter || defaultFormatLabel"
    :getInputLabel="(b) => b?.building_nm ?? ''"
    :placeholder="props.placeholder || '建物名またはIDで検索'"
    :required="props.required || false"
    :normalize-width="props.normalizeWidth"
  />
</template>

<script setup>
import SelectableSearch from './SelectableSearch.vue'

const props = defineProps({
  modelValue: [String, Number, null],
  options: {
    type: Array,
    required: true
  },
  formatter: Function,
  placeholder: String,
  required: Boolean,
  normalizeWidth: Boolean,
  allowCustom: Boolean,
  customValue: {
    type: String,
    default: ''
  },
  maxLength: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'update:customValue'])

const defaultFormatLabel = (b) => `${b.building_nm}（ID: ${b.id}）`
</script>
